var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie_chart"},[_c('Pie',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"plugins":_vm.pieChartPlugins,"dataset-id-key":"label","chart-id":"pie-chart","height":_vm.height,"width":_vm.width}}),_c('p',{staticClass:"pie_chart__sub-title"},[_vm._v(_vm._s(_vm.chartBottomText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }